module.exports = "<!-- Topbar Start -->\r\n<div class=\"navbar-custom d-md-none\">\r\n    <button class=\"button-menu-mobile open-left disable-btn\">\r\n        <i class=\"mdi mdi-menu\"></i>\r\n    </button>\r\n</div>\r\n<!-- end Topbar -->"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/partials/mobile-bar/mobile-bar.component.html
// module id = ./src/app/components/partials/mobile-bar/mobile-bar.component.html
// module chunks = main